export * from './animal-cohort-table.component';
